// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__2oRNU","text":"SelectPayment_text__3rINq","title":"SelectPayment_title__8irYC","btn":"SelectPayment_btn__3EEXi"};